import { FC } from 'react';

import { FooterLink } from './styled';

export type MenuItem = {
  name: string;
  href: string;
};

export type MenuProps = {
  items: Array<MenuItem>;
};

const SubProduct: FC<MenuProps> = ({ items }) => {
  return (
    <>
      {items.map((item, i) => (
        <FooterLink
          key={`${item.name}-${i}`}
          href={`${item.href}`}
          data-testid='product-links'
        >
          {item.name}
        </FooterLink>
      ))}
    </>
  );
};
export default SubProduct;
